module.exports = __webpack_public_path__ + "static/img/200243.07db3043.png";